import React from 'react';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';

const ApartmentField = ({
  id = 'apartment',
  name = 'apartment',
  value,
  error,
  showError,
  isTouched,
  handleBlur,
  handleChange,
  placeholder,
  ...props
}) => (
  <LabeledTextInput
    id={id}
    type="text"
    name={name}
    label={placeholder || 'Apartment / suite # (optional)'}
    onChange={handleChange}
    onBlur={handleBlur}
    value={value}
    autoComplete="address-line2"
    data-xc="shipping-apartment-field"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    errorMessage={showError && isTouched && error ? error : null}
  />
);

ApartmentField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  showError: PropTypes.bool,
  value: PropTypes.string,
};

export default ApartmentField;
